import { useState, useEffect } from "react";

const useFocusOnMount = (isDisplayingElement, containerRef) => {
  const [shouldDisplayError, setDisplayError] = useState(isDisplayingElement);

  useEffect(() => {
    if (!isDisplayingElement) {
      setDisplayError(false);
    } else {
      setDisplayError(true);
    }
  }, [isDisplayingElement]);

  useEffect(() => {
    if (containerRef.current && shouldDisplayError) {
      containerRef.current.focus();
    }
  }, [shouldDisplayError, containerRef]);
};

export default useFocusOnMount;
